import React, { Component } from "react";
import { Menu, Icon, Modal, message } from "antd";
import TransferBFilesModal from "./components/transfer-bfiles-modal";
import UploadCustomersEAModal from "./components/upload-customers-ea-modal";
import UploadCustomersRSModal from "./components/upload-customers-rs-modal";
import UploadCustomersVonModal from "./components/upload-customers-von-modal";
import UploadCustomersAdminModal from "./components/upload-customers-admin-modal";
import UploadDncCustomerModal from "./components/upload-dnc-customer";
import HelpModal from "./components/help-modal";
import { Translate } from "react-translated";
import F from "./Functions";
import axios from "./api";
import Cookies from "js-cookie";
import { BFILE_HAS_BEEN_UPDATED, DISCARD_BFILE_CONFIRMATION, MANDATORY_FIELDS_ERROR, NO, PLEASE_FILL_ALL_REQUIRED_FIELD, PROFILE_SAVED_FOR_LATER, PROFILE_UPDATED_SUCCESSFULLY, YES, PHONE_NUMBER_INVALID, EMAIL_ADDRESS_IS_INVALID } from './utils/Constants';
import lastLogin from "./assets/new_menu_icons/last_login.svg";

// store 
import { useBoundStore } from "./store/useBoundStore";

const SubMenu = Menu.SubMenu;

//LIVE CHAT CODE
// window.openChat = () => {
//   F.log("Open Chat");
//   window.LC_API && window.LC_API.open_chat_window && window.LC_API.open_chat_window();
// };


// window.openChat = () => {
//  console.log("Open Chat");
//  console.log("window.HubSpotConversations", window.HubSpotConversations);
//  console.log("window.HubSpotConversations.widget", window.HubSpotConversations && window.HubSpotConversations.widget);
//  const container = document.getElementById('hubspot-messages-iframe-container');
//  console.log("HubSpot Messages Container:", container);
//  if (container) {
//     container.style.display = 'block !important';
//     container.style.visibility = 'visible !important';
//   }
//   console.log("container.style.display", container ? container.style.display : 'container not found');
//   console.log("container.style.visibility", container ? container.style.visibility : 'container not found');
//   if (window.HubSpotConversations && window.HubSpotConversations.widget) {
//     window.HubSpotConversations.widget.open();
//   }
// };


window.openChat = () => {
  const container = document.getElementById('hubspot-messages-iframe-container');
  if (container) {
    container.style.setProperty('display', 'block', 'important');
  }

  if (!window.HubSpotConversations || !window.HubSpotConversations.widget) return;

  const status = window.HubSpotConversations.widget.status();
  if (status.loaded) {
    window.HubSpotConversations.widget.open();
  } else {
    window.HubSpotConversations.widget.load({ widgetOpen: true });
  }
};

class DashMenu extends Component {
  state = {
    count: 1,
    user: this.props.user,
    user_active: null,
    transfer_bfiles_modal: false,
    upload_customers_ea_modal: false,
    upload_customers_rs_modal: false,
    upload_customers_von_modal: false,
    upload_customers_admin_modal: false,
    upload_dnc_customer_modal: false,
    help_modal: false,
    agencyStaffList: [],
    agency_id: null,
    reviewSchedulerAgenciesList: [],
    vonAgenciesList: [],
    adminAgenciesList: [],
    agency_id_rs: null,
    agency_id_von: null,
    openKeys: [],
    isWizardValueUpdated: false
  };

  componentDidMount() {

    if (this.state.user.user_type === 'EA' && this.state.user.id == 2) {
      this.setState({ openKeys: ['all-bfiles', 'bfiles'] })
    }
  }



  showUploadCustomerModal() {
    this.setState({ upload_customers_ea_modal: true });

    axios.get("/api/my_associations").then((res) => {
      let agencyStaffList = [];
      for (let x in res.data) {
        const agency = res.data[x];
        for (let i = 0; i < agency.length; i++) {
          const u = agency[i];
          // if (u.user_type === "LSP") {
          //   agencyStaffList.push({
          //     name: u.first_name + " " + u.last_name,
          //     id: u.id,
          //     user_type: u.user_type,
          //   });
          // }
          agencyStaffList.push({
            name: u.first_name + " " + u.last_name,
            id: u.id,
            user_type: u.user_type,
          });
        }
      }

      this.setState({
        agencyStaffList,
      });
    });

    axios.get("/api/user").then((res) => {
      const u = res.data;
      let agency_id = null;
      if (res.data.user_agency_assoc && res.data.user_agency_assoc.length > 0) {
        agency_id = res.data.user_agency_assoc[0].agency_id || null;
      }

      let CokkeeData = typeof Cookies.get("user_info") !== "undefined"
        ? JSON.parse(Cookies.get("user_info"))
        : {};
      let temp = {
        ...CokkeeData,
        agency_id: res.data.user_agency_assoc ? res.data.user_agency_assoc[0] ? res.data.user_agency_assoc[0].agency_id : null : null
      }

      Cookies.set("user_info", JSON.stringify(temp),
        {
          secure: true,           //  HTTPS only
          sameSite: 'Lax',        // Add this — fixes the scan finding
          path: '/',              // explicit path
        }
      )

      this.setState({ agency_id });
    });
  }

  showReviewSchedulerUploadCustomerModal() {
    this.setState({ upload_customers_rs_modal: true });

    axios.get("/api/user").then((res) => {
      const u = res.data;
      let agency_id_rs = null;
      if (res.data.user_agency_assoc && res.data.user_agency_assoc.length > 0) {
        agency_id_rs = res.data.user_agency_assoc[0].agency_id || null;
      }

      let CokkeeData = typeof Cookies.get("user_info") !== "undefined"
        ? JSON.parse(Cookies.get("user_info"))
        : {};

      let temp = {
        ...CokkeeData,
        agency_id: res.data.user_agency_assoc ? res.data.user_agency_assoc[0] ? res.data.user_agency_assoc[0].agency_id : null : null
      }

      Cookies.set("user_info", JSON.stringify(temp),
        {
          secure: true,           //  HTTPS only
          sameSite: 'Lax',        // Add this — fixes the scan finding
          path: '/',              // explicit path
        }
      )

      // this.setState({ agency_id });
      this.setState({ agency_id_rs });
      if (
        u.user_type === "REVIEWSCHEDULER" ||
        u.user_type === "RSO" ||
        u.user_type === "EA"
      ) {
        axios.get("/api/rs_agencies").then((res) => {
          this.setState({
            // agencies: res.data,
            reviewSchedulerAgenciesList: res.data,
          });
        });
      }
    });
  }

  showVonUploadCustomerModal() {
    this.setState({ upload_customers_von_modal: true });

    axios.get("/api/user").then((res) => {
      const u = res.data;
      let agency_id_von = null;
      if (res.data.user_agency_assoc && res.data.user_agency_assoc.length > 0) {
        agency_id_von = res.data.user_agency_assoc[0].agency_id || null;
      }

      let CokkeeData = typeof Cookies.get("user_info") !== "undefined"
        ? JSON.parse(Cookies.get("user_info"))
        : {};

      let temp = {
        ...CokkeeData,
        agency_id: res.data.user_agency_assoc ? res.data.user_agency_assoc[0] ? res.data.user_agency_assoc[0].agency_id : null : null
      }

      Cookies.set("user_info", JSON.stringify(temp),
        {
          secure: true,           //  HTTPS only
          sameSite: 'Lax',        // Add this — fixes the scan finding
          path: '/',              // explicit path
        }
      )
      // this.setState({ agency_id });
      this.setState({ agency_id_von });
      if (
        u.user_type === "REVIEWSCHEDULER" ||
        u.user_type === "RSO" ||
        u.user_type === "EA" ||
        u.user_type === "VONBOARDER" // new add
      ) {
        axios.get("/api/vo_agencies").then((res) => {
          this.setState({
            // agencies: res.data,
            vonAgenciesList: res.data,
          });
        });
      }
    });
  }

  showAdminUploadCustomerModal() {
    this.props.history.push('/super-admin')
    this.setState({ upload_customers_admin_modal: true });
    axios.get("/api/user").then((res) => {

      let CokkeeData = typeof Cookies.get("user_info") !== "undefined"
        ? JSON.parse(Cookies.get("user_info"))
        : {};

      let temp = {
        ...CokkeeData,
        agency_id: res.data.user_agency_assoc ? res.data.user_agency_assoc[0] ? res.data.user_agency_assoc[0].agency_id : null : null
      }

      Cookies.set("user_info", JSON.stringify(temp),
        {
          secure: true,           //  HTTPS only
          sameSite: 'Lax',        // Add this — fixes the scan finding
          path: '/',              // explicit path
        }
      )

      // const u = res.data;
      // let agency_id_von = null;
      // for (let i = 0; i < u.user_agency_assoc.length; i++) {
      //   agency_id_von = u.user_agency_assoc[i].agency_id;
      //   break;
      // }
      // this.setState({ agency_id });
      // this.setState({ agency_id_von });
      // const isLocalHost = window.location.hostname === "localhost";
      axios.get("/api/admin_agencies").then((res) => {
        this.setState({
          // agencies: res.data,
          adminAgenciesList: res.data,
        });
      });
    });
  }

  showDncCustomerModal() {
    this.setState({ upload_dnc_customer_modal: true });

    axios.get("/api/user").then((res) => {
      // const u = res.data;
      // let agency_id_von = null;
      // for (let i = 0; i < u.user_agency_assoc.length; i++) {
      //   agency_id_von = u.user_agency_assoc[i].agency_id;
      //   break;
      // }
      // this.setState({ agency_id });
      // this.setState({ agency_id_von });
      // const isLocalHost = window.location.hostname === "localhost";
      axios.get("/api/admin_agencies").then((res) => {
        this.setState({
          // agencies: res.data,
          adminAgenciesList: res.data,
        });
      });
    });
  }

  handleClick = (path, state) => {
    // console.log("state",state)
    useBoundStore.getState().setUserType({ userType: state.user_type })
    const pathData = window.location.hash.split("/");
    const wizard = JSON.parse(localStorage.getItem('wizard'));
    const newWizard = pathData.includes("wizard?new");
    const alreadySavedWizard = pathData.includes('wizard') && pathData.includes('step');

    if ((newWizard || alreadySavedWizard)
      && wizard && (!wizard.first_name || !wizard.last_name || !wizard.phone)) {
      if (wizard.id) {
        message.error(PLEASE_FILL_ALL_REQUIRED_FIELD);
        return;
      } else {
        Modal.confirm({
          title: MANDATORY_FIELDS_ERROR,
          content: DISCARD_BFILE_CONFIRMATION,
          okText: NO,
          cancelText: YES,
          onOk: () => {
          },
          onCancel: () => {
            window.localStorage.removeItem('wizard');
            this.props.history.push({ pathname: path, state: state })
            this.props.handleClick({ keyPath: this.state.openKeys });
          },
          okButtonProps: {
            className: 'borderRadius-28 bg-164897',
            style: {
              color: 'white'
            }
          },
          cancelButtonProps: {
            className: 'borderRadius-28',

          }
        });
      }
      return;
    }
    if ((newWizard || alreadySavedWizard) && wizard && (wizard.phone)) {
      const input = wizard.phone;
      const inputValue = input.replace(/\D/g, '');
      if (inputValue.length != 10) {
        message.error(PHONE_NUMBER_INVALID);
        return;
      }

      if (wizard.email && !F.validateEmail(wizard.email) && wizard.email != '') {
        message.error(EMAIL_ADDRESS_IS_INVALID);
      }
    }

    //NEW Intelligence Link and PROPS VALUE UPDATED TO TRUE (AFTER GETTING RESPONSE ID) (AND IS SAVED FOR LATER - 1);
    if (newWizard && this.props.isWizardValueUpdated && wizard.is_saved_for_later == 1) {
      message.success(PROFILE_SAVED_FOR_LATER);
      this.props.setWizardValue({ isWizardValueUpdated: false });
    }

    //ALREADY SAVED FOR LATER and PROPS VALUE UPDATED TO TRUE (AFTER GETTING RESPONSE) (AND IS SAVED FOR LATER - 1);
    else if (alreadySavedWizard && this.props.isWizardValueUpdated && wizard.is_saved_for_later == 1) {
      message.success(PROFILE_SAVED_FOR_LATER);
      this.props.setWizardValue({ isWizardValueUpdated: false });
    }


    else if (alreadySavedWizard && this.props.isWizardValueUpdated && wizard.is_saved_for_later == 0) {
      message.success(BFILE_HAS_BEEN_UPDATED);
      this.props.setWizardValue({ isWizardValueUpdated: false });
    }

    this.props.history.replace({ pathname: path, state: state })
  };

  getIcon = (iconName) => {

    if (iconName === "email_template") {
      return <Icon type="mail" theme="filled" />;
    }

    try {
      // Dynamically require the icon based on the iconName
      const iconPath = require(`./assets/new_menu_icons/${iconName}.svg`);
      return <img src={iconPath} alt={iconName} style={{ marginRight: this.props.collapsed ? "0px" : '10px', width: '18px', height: '18px' }} />
    } catch (error) {
      console.error(`Icon ${iconName} not found`, error);
      return <span>Icon not found</span>;
    }
  }


  render() {
    const { selected_key, handleClick, goTo, user, selected_menu, menu } = this.props;
    if (selected_key) {
      F.log("selected_key==>>" + JSON.stringify(selected_key));
    }


    const onOpenChange = openKeys => {
      const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
      if (menu.map(e => e.key).indexOf(latestOpenKey) === -1) {
        this.setState({ openKeys });
      } else {
        this.setState({
          openKeys: latestOpenKey ? [latestOpenKey] : [],
        });

      }
      handleClick({ keyPath: openKeys })
    };

    const functions = {
      showUploadCustomerModal: this.showUploadCustomerModal.bind(this),
      showReviewSchedulerUploadCustomerModal: this.showReviewSchedulerUploadCustomerModal.bind(this),
      showDncCustomerModal: this.showDncCustomerModal.bind(this),
      showAdminUploadCustomerModal: this.showAdminUploadCustomerModal.bind(this),
      openChat: window.openChat.bind(this),
    };

    return (
      <div>
        <Menu
          // selectedKeys={selected_key ? selected_key.split(",") : null}
          selectedKeys={selected_key}
          // defaultSelectedKeys={["dashboard", "bfiles", "archived"]}
          mode="inline"
          style={{ background: 'transparent', color: 'white' }}
          onClick={(e) => { onOpenChange(e.keyPath) }}
          onOpenChange={onOpenChange}
          openKeys={this.state.openKeys}

          // Menu side Pop-Up Fix after global antd fix
          getPopupContainer={trigger => document.body}
          // Spacing away from sidebar issue
          inlineCollapsed={this.props.collapsed}


        >
          {menu.filter((e) => e.hasOwnProperty("active") ? e.active === user.active : true).map((item, i) => {
            if (typeof item.menu !== "undefined") {
              return (
                <SubMenu
                  key={item.key}
                  // style={{background:'transparent'}}
                  title={
                    <div className="menuicontext">
                      <div style={{ display: "flex", alignItems: "center" }} >
                        {/* {['EA'].includes(user.user_type) && user.id !== 2 ? <img src={require(`./assets/icons/menu/${item.icon}.png`)} style={{ marginRight: "5px" }} width={22} /> : <Icon type={item.icon} />} */}

                        {item && item.iconKey && item.iconKey !== "" ? (
                          this.getIcon(item.iconKey)
                        ) : (
                          <Icon type={item.icon} />
                        )}
                        {/* <Icon type={item.icon} /> */}
                      </div>
                      <div className="submenutitle">
                        <Translate text={item.title} />
                      </div>
                    </div>
                  }
                  // Spacing away from sidebar issue
                  popupClassName="sidebar-popup-menu"
                >
                  {item.menu.map((subitem) => {
                    if (typeof subitem.menu !== "undefined") {
                      return (
                        <SubMenu
                          key={subitem.key}
                          // style={{background:'transparent'}}
                          title={
                            <span>
                              {/* <Icon type={subitem.icon} /> */}
                              <span>
                                <Translate text={subitem.title} />
                              </span>
                            </span>
                          }
                          // Spacing away from sidebar issue
                          popupClassName="sidebar-popup-menu"
                        >
                          {subitem.menu.map((nestedSubItem) => {
                            return (
                              <Menu.Item
                                key={nestedSubItem.key}
                                // style={{background:'transparent'}}
                                onClick={() => {
                                  if (
                                    typeof nestedSubItem.onClick !== "undefined"
                                  ) {
                                    functions[nestedSubItem.onClick]();
                                    // nestedSubItem.onClick();
                                  } else if (nestedSubItem.path !== "") {
                                    this.handleClick(nestedSubItem.path, {
                                      ...nestedSubItem,
                                      component: nestedSubItem.key,
                                    });
                                    // this.props.history.push({
                                    //   pathname: nestedSubItem.path,
                                    //   state: { ...nestedSubItem, component: nestedSubItem.key },
                                    // });
                                  }
                                }}
                              >
                                <Translate text={nestedSubItem.title} />
                              </Menu.Item>
                            );
                          })}
                        </SubMenu>
                      );
                    } else {
                      return (
                        <Menu.Item
                          // style={{background:'transparent'}}
                          key={subitem.key}
                          onClick={() => {
                            // console.log("subitem",subitem)
                            localStorage.setItem("menuTitle", subitem.title)
                            if (typeof subitem.onClick !== "undefined") {
                              functions[subitem.onClick]();
                              // subitem.onClick();
                            } else if (subitem.path !== "") {
                              this.handleClick(subitem.path, {
                                ...subitem,
                                component: subitem.key,
                              });
                              // this.props.history.push({
                              //   pathname: subitem.path,
                              //   state: { ...subitem, component: subitem.key },
                              // });
                            }
                          }}
                        >
                          <Translate text={subitem.title} />
                        </Menu.Item>
                      );
                    }
                  })}
                </SubMenu>
              );
            } else {
              let marginTop = '0px';
              if (item.key === 'dashboard' && !this.props.collapsed) {
                marginTop = '5px';
              }
              return (
                <Menu.Item
                  // style={{background:'transparent'}}
                  id={"menu-" + i + item.key}
                  key={item.key}
                  onClick={() => {
                    localStorage.setItem("menuTitle", item.title)
                    this.setState((prevState) => ({ count: prevState.count + 1 }));
                    if (typeof item.onClick !== "undefined") {
                      functions[item.onClick]();
                      // item.onClick();
                    } else if (item.path !== "") {
                      this.handleClick(item.path, this.state.count)
                      // this.props.history.push({
                      //   pathname: item.path,
                      //   state: this.state.count,
                      // });
                    }
                  }}
                >
                  <div className="menuicontext">
                    <div>
                      {/* {['EA'].includes(user.user_type) && user.id !== 2 ? <img src={require(`./assets/icons/menu/${item.icon}.png`)} style={{ marginRight: "5px" }} width={22} /> : <Icon type={item.icon} />} */}
                      {item && item.iconKey && item.iconKey !== "" ? (
                        this.getIcon(item.iconKey)
                      ) : (
                        <Icon type={item.icon} />
                      )}
                      {/* <Icon type={item.icon} /> */}
                    </div>
                    <div className="title">
                      <Translate text={item.title} />
                    </div>
                  </div>
                  {/* <Icon type={item.icon} />
                    <Translate text={item.title} /> */}

                </Menu.Item>
              );
            }
          })}
        </Menu>
        <TransferBFilesModal
          history={this.props.history}
          showModal={this.state.transfer_bfiles_modal}
          hideModal={() => this.setState({ transfer_bfiles_modal: false })}
          user={this.state.user}
        />

        {this.state.upload_customers_ea_modal ? (
          <UploadCustomersEAModal
            history={this.props.history}
            showModal={this.state.upload_customers_ea_modal}
            hideModal={() =>
              this.setState({ upload_customers_ea_modal: false })
            }
            user={this.state.user}
            agencyStaffList={this.state.agencyStaffList}
            agency_id={this.state.agency_id}
          />
        ) : null}

        {this.state.upload_customers_rs_modal ? (
          <UploadCustomersRSModal
            history={this.props.history}
            showModal={this.state.upload_customers_rs_modal}
            hideModal={() =>
              this.setState({ upload_customers_rs_modal: false })
            }
            user={this.state.user}
            reviewSchedulerAgenciesList={this.state.reviewSchedulerAgenciesList}
            agency_id={this.state.agency_id_rs}
          />
        ) : null}

        {this.state.upload_customers_von_modal ? (
          <UploadCustomersVonModal
            history={this.props.history}
            showModal={this.state.upload_customers_von_modal}
            hideModal={() =>
              this.setState({ upload_customers_von_modal: false })
            }
            user={this.state.user}
            vonAgenciesList={this.state.vonAgenciesList}
            agency_id={this.state.agency_id_von}
          />
        ) : null}

        {this.state.upload_customers_admin_modal ? (
          <UploadCustomersAdminModal
            history={this.props.history}
            showModal={this.state.upload_customers_admin_modal}
            hideModal={() =>
              this.setState({ upload_customers_admin_modal: false })
            }
            user={this.state.user}
            adminAgenciesList={this.state.adminAgenciesList}
            agency_id={this.state.agency_id_von}
          />
        ) : null}

        {this.state.upload_dnc_customer_modal ? (
          <UploadDncCustomerModal
            history={this.props.history}
            showModal={this.state.upload_dnc_customer_modal}
            hideModal={() =>
              this.setState({ upload_dnc_customer_modal: false })
            }
            user={this.state.user}
            adminAgenciesList={this.state.adminAgenciesList}
            agency_id={this.state.agency_id_von}
          />
        ) : null}

        <HelpModal
          history={this.props.history}
          showModal={this.state.help_modal}
          hideModal={() => this.setState({ help_modal: false })}
          user={this.state.user}
        />
      </div>
    );
  }
}

export default DashMenu;



// WEBPACK FOOTER //
// ./src/Menu.js